module.exports = __webpack_public_path__ + "static/img/2099_phase_function_Paper_PointsHejduk_Prediction.b1477a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2099_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 0PBd
// module chunks = 0